import { useEffect, useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { memes } from '@/mocks/home';

export default function Memes() {
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setPreview(null);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const active = memes.find((meme) => meme.id === preview);

  return (
    <section id="memes" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          align="center"
          eyebrow="表情包共赏"
          title="聊天没词的时候，让它们替你说话"
          desc="画风统一、情绪到位。点开可以放大查看，长按或右键保存后就能直接用在聊天里。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {memes.map((meme) => (
            <button
              key={meme.id}
              type="button"
              onClick={() => setPreview(meme.id)}
              className="group text-left rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-colors"
            >
              <div className="w-full aspect-square overflow-hidden">
                <img
                  src={meme.image}
                  alt={`表情包：${meme.caption}`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-300"
                />
              </div>
              <div className="p-3 md:p-4">
                <span className="text-[11px] px-2 py-0.5 rounded-full bg-primary-100 text-primary-700">
                  {meme.tag}
                </span>
                <p className="mt-2 text-sm text-foreground-800 leading-snug">{meme.caption}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div
          className="fixed inset-0 z-[60] bg-foreground-950/70 flex items-center justify-center p-4"
          role="dialog"
          aria-modal="true"
          aria-label={`表情包预览：${active.caption}`}
          onClick={() => setPreview(null)}
        >
          <div
            className="relative max-w-md w-full bg-background-50 rounded-lg overflow-hidden"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setPreview(null)}
              aria-label="关闭预览"
              className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-background-50/90 text-foreground-900 flex items-center justify-center hover:bg-background-100 transition-colors"
            >
              <i className="ri-close-line text-xl" />
            </button>
            <div className="w-full aspect-square">
              <img src={active.image} alt={`表情包大图：${active.caption}`} className="w-full h-full object-cover object-top" />
            </div>
            <div className="p-5 flex items-center justify-between gap-4">
              <div>
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700">
                  {active.tag}
                </span>
                <p className="mt-2 text-sm text-foreground-800">{active.caption}</p>
              </div>
              <a
                href={active.image}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 inline-flex items-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-download-2-line" />
                保存
              </a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}